import { ReactNode } from 'react';
import type { FormatterProps } from '../types/editor-config';

export function TextFormatter({ value }: FormatterProps): ReactNode {
  return (
    <span className='inline-flex flex-col gap-2xs items-start'>
      <span className='whitespace-pre-wrap'>{String(value)}</span>
    </span>
  );
}
